(function($) {
    $(document).ready(function() {
        $('.card__image__video').on('click', function(e) {
          e.preventDefault();
          let youtubeUrl = $(this).attr('href');
          $(this).parent().find(".card__image__play").hide();
          // Is it a vimeo video? Format would be https://vimeo.com/794814662/b4b663f012, and needs to become <iframe title="vimeo-player" src="https://player.vimeo.com/video/794814662?h=b4b663f012" width="640" height="360" frameborder="0" allowfullscreen></iframe>
          if (youtubeUrl.indexOf('vimeo') > -1) {
            
            let vimeoFirstId = youtubeUrl.split('/')[3];
            let vimeoSecondId = youtubeUrl.split('/')[4];
            let iframe = '<iframe style="width: 100%; height: 100%; aspect-ratio: 16/9;" title="vimeo-player" src="https://player.vimeo.com/video/' + vimeoFirstId + '?h=' + vimeoSecondId + '" width="640" height="360" frameborder="0" allowfullscreen></iframe>';
            
            $(this).replaceWith(iframe);
            return;
          }
          let youtubeId = youtubeUrl.split('v=')[1];
          let iframe = '<iframe style="width: 100%; height: 100%; aspect-ratio: 16/9;" src="https://www.youtube.com/embed/' + youtubeId + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
          $(this).replaceWith(iframe);
        });
    });
}(jQuery));